import * as React from 'react';
import classnames from 'classnames';

import SVGDynamicIcon from 'components/svg-dynamic-icon/SVGDynamicIcon';

import { __t, applyTranslations } from 'utils/language';

import './facebook-button-no-connect-trigger.scss';

applyTranslations(require('../facebook-button-no-connect.i18n.json'));

import type {
  FacebookButtonNoConnectToggle
} from '../types';

interface Props {
  toggle: FacebookButtonNoConnectToggle,
  onToggle: (toggle: FacebookButtonNoConnectToggle) => void
}

const MSG_KEY = 'facebook_button_no_connect';

const FacebookButtonNoConnectTrigger: React.FC<Props> = ({
  toggle = 'collapsed',
  onToggle
}: Props): JSX.Element => {
  const chevronClasses = classnames('facebook-button-no-connect-trigger__chevron', {
    [`facebook-button-no-connect-trigger__chevron--toggle-${toggle}`]: toggle
  });

  const handleToggle = (): void => {
    onToggle(toggle === 'collapsed' ? 'expanded' : 'collapsed');
  };

  return (
    <div
      className="facebook-button-no-connect-trigger"
      onClick={handleToggle}
    >
      <div className={chevronClasses}>
        <SVGDynamicIcon
          name="chevron-down-custom-fg"
          width={15}
          height={8}
          customColor="grey"
        />
      </div>
      <div className="facebook-button-no-connect-trigger__text">
        {__t(`${MSG_KEY}.trigger`)}
      </div>
    </div>
  );
};

export default FacebookButtonNoConnectTrigger;
